import { FormattedMessage } from 'react-intl';
import React from 'react';

import { Alert, AlertDescription, LegacyButton } from '@zapier/design-system';

import { getSettingsUrl } from 'app/developer-v3/utils';
import { useAvroEvent } from 'app/developer-v3/hooks';

type Props = {
  integrationId: string;
  onDismiss: () => void;
};

function AlertMissingSettings({ integrationId, onDismiss }: Props) {
  const { correlationIds, emitPartnerUserInteractionEvent } = useAvroEvent();
  return (
    <Alert
      onDismiss={onDismiss}
      status="warning"
      title="Missing Integration Settings"
    >
      <AlertDescription>
        <FormattedMessage
          defaultMessage="Required fields are missing. Please update your Integration Settings. This info helps Zapier provide you with the best developer experience."
          id="messages-required-fields-missing-update-integration-settings"
        />
      </AlertDescription>
      <LegacyButton
        color="primary"
        hasShadow={true}
        href={`${getSettingsUrl(integrationId)}`}
        onClick={() => {
          emitPartnerUserInteractionEvent({
            correlationId:
              correlationIds.update_integration_settings_prompt_displayed,
            eventAction: 'click',
            interactionGoal: 'Update integration settings',
            interactionName: 'update_integration_settings_prompt_clicked',
          });
        }}
      >
        <FormattedMessage
          defaultMessage="Update Integration Settings"
          id="buttons-update-integration-settings"
        />
      </LegacyButton>
    </Alert>
  );
}

export default AlertMissingSettings;
